import * as React from 'react'
import { FC } from 'react'
import Grid from '@mui/material/Grid'
import { getStyles } from './styling'
import { useTheme } from '@mui/material/styles'

export const SoldServicesStatusTooltip: FC = () => {
  const styles = getStyles(useTheme())
  return (
    <Grid sx={styles.root} container>
      <Grid container item sx={styles.title}>
        Status Key
      </Grid>
      <Grid container item>
        <Grid item sx={styles.statusName} xs={3}>
          Created
        </Grid>
        <Grid item sx={styles.statusDescription} xs={9}>
          Service has been added to the customer&apos;s account
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item sx={styles.statusName} xs={3}>
          Scheduled
        </Grid>
        <Grid item sx={styles.statusDescription} xs={9}>
          Service has been scheduled
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item sx={styles.statusName} xs={3}>
          Serviced
        </Grid>
        <Grid item sx={styles.statusDescription} xs={9}>
          Service has been rendered at least once
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item sx={styles.statusName} xs={3}>
          Cancelled
        </Grid>
        <Grid item sx={styles.statusDescription} xs={9}>
          Service has been cancelled at some point
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item sx={styles.statusName} xs={3}>
          Revise
        </Grid>
        <Grid item sx={styles.statusDescription} xs={9}>
          Opportunity has been rejected
        </Grid>
      </Grid>
    </Grid>
  )
}

SoldServicesStatusTooltip.displayName = 'SoldServicesStatusTooltip'
